import React from "react";
import { FormControl, TextInput, Checkbox, RadioButtonGroup } from "glic-ui-components";
import { map, get } from "lodash";
import "./index.css";

const FormComponent = (props) => {
  const {
    fields,
    onChange,
    onBlur,
    onValidate,
    onKeyDown,
    onKeyUp,
    onPaste,
    validatorComponent,
    values = {},
  } = props;
  return (
    <div className="row">
      {map(fields, (field, index) => {
        console.log("fieldss>>>", field);
        const fieldValidator = get(validatorComponent, [field.id], null);
        switch (field.type) {
          case "text":
          case "password":
            let formControlClassName = field.formControlClassName;
            let textInputClassName = field.className;
            return (
              <>
                <div className={field.wrapperClassName} key={field.id}>
                  <FormControl
                    validations={field.validation}
                    validateOnChange={field.validateOnChange}
                    validateOnBlur={field.validateOnBlur}
                    showOptionalText={field.isOptional}
                    className={formControlClassName}
                    width={field.formControlWidth}
                    key={field.id}
                    onValidate={onValidate}
                  >
                    <FormControl.Label
                      htmlFor={field.id}
                      id={field.labelId}
                      className={field.labelClassName}
                    >
                      {field.title}
                    </FormControl.Label>
                    <TextInput
                      aria-describedby={field.ariaDescribedBy}
                      id={field.id}
                      name={field.id}
                      type={field.type}
                      onChange={onChange}
                      onKeyDown={onKeyDown}
                      onKeyUp={onKeyUp}
                      onPaste={onPaste}
                      tabIndex="0"
                      required={field.required}
                      className={textInputClassName}
                      onBlur={onBlur}
                      value={values[field.id]}
                      maxLength={field?.maxlength}
                      placeholder={field?.placeholder}
                    />
                  </FormControl>
                  {field.info && (
                    <div
                      id="broker-field-info"
                      className="broker-comp-input-info"
                      aria-live="assertive"
                    >
                      {field.info}
                    </div>
                  )}
                  {fieldValidator}
                </div>
              </>
            );
          case "checkbox":
            console.log("field.Options>>>>", field.Options);
            return (
              <div>
                <FormControl
                  validations={field.validation}
                  key={field.formsControlId}
                  validateOnChange
                >
                  <FormControl.Label
                    htmlFor={field.id}
                    id={field.labelId}
                    className={field.labelClassName}
                  >
                    {field.title}
                  </FormControl.Label>
                  <Checkbox
                    id={field.id}
                    name={field.name}
                    label={field.label}
                    items={field.Options}
                    onChange={onChange}
                    onBlur={onBlur}
                    aria-describedby={field.ariaDescribedBy}
                  />
                </FormControl>
                {fieldValidator}
              </div>
            );
          case "radio":
            return (
              <div>
                <FormControl
                  validations={field.validation}
                  key={field.formsControlId}
                  validateOnChange
                >
                  <FormControl.Label
                    htmlFor={field.id}
                    id={field.labelId}
                    className={field.labelClassName}
                  >
                    {field.title}
                  </FormControl.Label>
                  <RadioButtonGroup
                    id={field.id}
                    name={field.name}
                    items={field.Options}
                    selected={field.selected}
                    aria-describedby={field.ariaDescribedBy}
                    onBlur={onBlur}
                    onChange={onChange}
                  />
                </FormControl>
                {fieldValidator}
              </div>
            );
          default:
            return null;
        }
      })}
    </div>
  );
};

export const Form = FormComponent;